function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_776",
  "data-name": "Path 776",
  fill: "#5273e6",
  d: "M12.645,42.906a1.262,1.262,0,0,1-.885-.365,1.249,1.249,0,0,1-.342-1.128l1.767-8.837a1.225,1.225,0,0,1,.343-.64L32.973,12.491a3.757,3.757,0,0,1,5.3,0l3.535,3.535a3.753,3.753,0,0,1,0,5.3L22.365,40.773a1.243,1.243,0,0,1-.64.342l-8.837,1.768A1.326,1.326,0,0,1,12.645,42.906Zm2.92-9.472L14.24,40.061l6.627-1.325L40.045,19.559a1.251,1.251,0,0,0,0-1.767L36.51,14.256a1.251,1.251,0,0,0-1.767,0Zm5.917,6.455h.025Z",
  transform: "translate(17.09 17.094)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_777",
  "data-name": "Path 777",
  fill: "#5273e6",
  d: "M23.75,48H6.25A6.255,6.255,0,0,1,0,41.75V9.25A6.255,6.255,0,0,1,6.25,3h5a1.25,1.25,0,0,1,0,2.5h-5A3.755,3.755,0,0,0,2.5,9.25v32.5A3.755,3.755,0,0,0,6.25,45.5h17.5a1.25,1.25,0,0,1,0,2.5Z",
  transform: "translate(0 4.5)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_778",
  "data-name": "Path 778",
  fill: "#5273e6",
  d: "M23.25,25.5A1.25,1.25,0,0,1,22,24.25v-15A3.755,3.755,0,0,0,18.25,5.5h-5a1.25,1.25,0,1,1,0-2.5h5A6.255,6.255,0,0,1,24.5,9.25v15A1.25,1.25,0,0,1,23.25,25.5Z",
  transform: "translate(18 4.5)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_779",
  "data-name": "Path 779",
  fill: "#5273e6",
  d: "M22.75,15h-15A3.755,3.755,0,0,1,4,11.25v-5A1.25,1.25,0,0,1,5.25,5H9.125a6.252,6.252,0,0,1,12.25,0H25.25A1.25,1.25,0,0,1,26.5,6.25v5A3.755,3.755,0,0,1,22.75,15ZM6.5,7.5v3.75A1.254,1.254,0,0,0,7.75,12.5h15A1.254,1.254,0,0,0,24,11.25V7.5H20.25A1.25,1.25,0,0,1,19,6.25a3.75,3.75,0,0,0-7.5,0A1.25,1.25,0,0,1,10.25,7.5Z",
  transform: "translate(6)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_780",
  "data-name": "Path 780",
  fill: "#5273e6",
  d: "M29.25,10.5h-25a1.25,1.25,0,0,1,0-2.5h25a1.25,1.25,0,0,1,0,2.5Z",
  transform: "translate(4.5 12)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_781",
  "data-name": "Path 781",
  fill: "#5273e6",
  d: "M29.25,13.5h-25a1.25,1.25,0,0,1,0-2.5h25a1.25,1.25,0,0,1,0,2.5Z",
  transform: "translate(4.5 16.5)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_782",
  "data-name": "Path 782",
  fill: "#5273e6",
  d: "M29.25,16.5h-25a1.25,1.25,0,0,1,0-2.5h25a1.25,1.25,0,0,1,0,2.5Z",
  transform: "translate(4.5 21)"
});

var SvgEditHomework = function SvgEditHomework(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_Homework",
    "data-name": "Edit Homework",
    viewBox: "0 0 59.997 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditHomework, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-homework.5ccc4413.svg";
export { ForwardRef as ReactComponent };